import {defineMessages} from 'react-intl'
import R from 'ramda'

import {getSummaries} from '../api/search'

import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: "Something bad happened", 
    defaultMessage: "Something bad happened"
  },
  message: {
    id: "Details of this estate can't be retrieved, try again later", 
    defaultMessage: "Details of this estate can't be retrieved, try again later"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, estateSummaries) => {
  if(err){
    dispatch(addNotification(notification))
    return console.error("failed to fetch detail for as estate", err)
  }
  dispatch({type:"load_estates", estates: estateSummaries})
}

export default (estatesIds) => (dispatch, getState) => {

  const isInCache = id => R.path(['estates', id, 'summary'], getState())
  const summariesToFetch = R.reject(isInCache, estatesIds)

  if(summariesToFetch.length)
    getSummaries(summariesToFetch, onComplete(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/loadSummaries.js
 **/